<template lang="pug">
#monitoramento-agricola
    .row
        .col-6
            .dados-monitoramento
                el-tabs(v-model='activeTab', type='border-card')
                    el-tab-pane(name='dadosCadastro')
                        span(slot='label')
                            i.el-icon-notebook-1.tab-icon
                            span Dados área monitorada
                        dados-area-monitorada(
                            v-if='dadosAreaMonitorada',
                            :areaMonitorada='dadosAreaMonitorada'
                        )

                    el-tab-pane(name='dadosMonitoramento')
                        span(slot='label')
                            i.el-icon-map-location.tab-icon
                            span Dados monitoramento
                        dados-monitoramento(
                            v-if='dadosAreaMonitorada',
                            :areaMonitorada='dadosAreaMonitorada',
                            :focusAreaPlantada='highlightAreaMonitorada'
                        )
        .col-6
            transition(name='el-fade-in-linear')
                mapa.map-content(
                    v-if='layersMaps',
                    :mapLayersConfigs='layersMaps',
                    :mapConfig='mapConfig',
                    :height='"500px"',
                    :idMapa='"mapaMonitoramento"',
                    ref='mapa'
                )

            visibilidade-camada-area-plantada(
                :onChange='toggleVisibilidadeCamadaAreaPlantada'
            )

    .row
        .col-6
            card.carousel-fix(
                title='Chuva e temperatura - previsão dos próximos 15 dias'
            )
                grafico-previsao-chuva-temperatura

        .col-6(
            v-loading='!dadosMonitoramentoAgro || !dadosPrecipitacaoSafraAtual'
        )
            card(title='Produtividade estimada da área monitorada no período')
                grafico-produtividade(
                    :dadosMonitoramento='dadosMonitoramentoAgro',
                    :dadosPrecipitacaoSafraAtual='dadosPrecipitacaoSafraAtual',
                    :dadosAreaMonitorada='dadosAreaMonitorada',
                    v-if='dadosMonitoramentoAgro && dadosPrecipitacaoSafraAtual'
                )

    .row(v-loading='!dadosMonitoramentoAgro || !dadosPrecipitacaoSafraAtual')
        .col-xl-12.col-sm-12
            card(
                title='Evolução do índice de vegetação da área monitorada no período',
                info='Índice de vegetação: Utilizado para avaliação das mudanças do vigor vegetativo dos cultivos.'
            )
                grafico-evolucao-indice-vegetacao(
                    :dadosMonitoramentoNDVI='dadosMonitoramentoAgro.monitoramentoNDVI',
                    :dadosPrecipitacaoSafraAtual='dadosPrecipitacaoSafraAtual',
                    v-if='dadosMonitoramentoAgro && dadosPrecipitacaoSafraAtual'
                )
</template>

<script>
import GraficoProdutividade from '@/components/areamonitorada/graficos/GraficoProdutividade';
import GraficoEvolucaoIndiceVegetacao from '@/components/areamonitorada/graficos/GraficoEvolucaoIndiceVegetacao';
import GraficoPrevisaoChuvaTemperatura from '@/components/areamonitorada/graficos/GraficoPrevisaoChuvaTemperatura';
import Card from '@/components/Card';
import MonitoramentoService from '@/services/MonitoramentoService';
import Mapa from '@/components/MapaLeaflet';
import LayerStyle from '@/utils/layerStyles';
import VisibilidadeCamadaAreaPlantada from '@/components/VisibilidadeCamadaAreaPlantada';
import DadosAreaMonitorada from '@/components/areamonitorada/DadosAreaMonitorada';
import DadosMonitoramento from '@/components/areamonitorada/DadosMonitoramento';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';

import L from 'leaflet';

export default {
    name: 'MonitoramentoAgricola',

    components: {
        VisibilidadeCamadaAreaPlantada,
        GraficoProdutividade,
        GraficoEvolucaoIndiceVegetacao,
        GraficoPrevisaoChuvaTemperatura,
        Card,
        Mapa,
        DadosAreaMonitorada,
        DadosMonitoramento
    },

    props: {
        dadosAreaMonitorada: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            carregando: true,
            layersMaps: null,
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true
                },
                dontZoomIn: false
            },
            dadosMonitoramentoAgro: null,
            dadosGraficosMonitoramento: null,
            dadosPrecipitacaoSafraAtual: null,
            loading: {
                alertas: false
            },
            activeTab: 'dadosMonitoramento',
            layerAreaPlantada: null,
            layersCulturaIdentificada: []
        };
    },

    methods: {
        findDadosGraficosMonitoramento() {
            MonitoramentoService.monitoramentoAgro(this.dadosAreaMonitorada.id)
                .then(({ data }) => {
                    this.carregando = false;
                    this.dadosMonitoramentoAgro = data;
                })
                .catch(() => {
                    this.$notify.error({
                        message:
                            'Ocorreu um erro ao buscar os dados de monitoramento'
                    });
                });

            this.dadosPrecipitacaoSafraAtual = [];
        },

        fetchRequests() {
            this.findDadosGraficosMonitoramento();
        },

        configureLayersMapa() {
            this.layersMaps = [];

            let layerAreaMonitorada = {
                style: getEstiloGeometria('area'),
                name: 'Área monitorada',
                geoJson: this.dadosAreaMonitorada.geometria
            };

            this.layersMaps.push(layerAreaMonitorada);

            this.layersCulturaIdentificada = [];

            this.dadosAreaMonitorada.dadosMonitoramento.dadosCulturasIdentificadas.forEach(
                (dadoCultura, index) => {
                    let culturaIdentificada =
                        dadoCultura.culturaIdentificada || {
                            nome: 'Não identificada',
                            codigo: 'NAO_IDENTIFICADA'
                        };
                    const estilo = culturaIdentificada
                        ? LayerStyle[culturaIdentificada.codigo]()
                        : LayerStyle.RESTRICAO();

                    let layerCulturaIdentificada = {
                        style: estilo,
                        name: 'Área plantada-' + index,
                        geoJson: dadoCultura.geometriaCulturaIdentificada,
                        tooltip: `Área plantada de ${culturaIdentificada.nome} - ${dadoCultura.areaCulturaIdentificadaHa} ha`
                    };

                    this.layersMaps.push(layerCulturaIdentificada);
                    this.layersCulturaIdentificada.push(
                        layerCulturaIdentificada
                    );
                }
            );

            if (
                this.dadosAreaMonitorada.dadosMonitoramento &&
                this.dadosAreaMonitorada.dadosMonitoramento
                    .geometriaAreaPlantada.length > 0 &&
                (!this.dadosAreaMonitorada.dadosMonitoramento
                    .dadosCulturasIdentificadas ||
                    !this.dadosAreaMonitorada.dadosMonitoramento
                        .dadosCulturasIdentificadas.length)
            ) {
                let layerAreaMonitorada = {
                    style: LayerStyle.AREA_PLANTADA_MONITORADA(),
                    name: 'Área plantada',
                    geoJson:
                        this.dadosAreaMonitorada.dadosMonitoramento
                            .geometriaAreaPlantada,
                    tooltip: `Área plantada ${this.dadosAreaMonitorada.dadosMonitoramento.areaPlantadaHa} ha`
                };

                this.layersMaps.push(layerAreaMonitorada);
                this.layerAreaPlantada = layerAreaMonitorada;
            }
        },

        toggleVisibilidadeCamadaAreaPlantada() {
            this.$refs.mapa.ativarDesativarCamadasPorNome([
                this.layerAreaPlantada
            ]);
            this.$refs.mapa.ativarDesativarCamadasPorNome(
                this.layersCulturaIdentificada
            );
        },
        highlightAreaMonitorada(areaPlantada) {
            const layer = L.geoJson(areaPlantada.geometriaCulturaIdentificada);
            this.$refs.mapa.mapa.addLayer(layer);
            setTimeout(() => this.$refs.mapa.mapa.removeLayer(layer), 2000);
        }
    },
    mounted() {
        this.configureLayersMapa();
        this.fetchRequests();
    }
};
</script>

<style lang="scss" scoped>
#monitoramento-agricola {
    .map-content {
        border-radius: 4px;
        overflow: hidden;
    }

    .row {
        margin-bottom: 20px;
        gap: 20px;
        justify-content: center;

        h1 {
            display: block;
            text-align: left;
        }
    }

    .col-6 {
        padding: 0;
        max-width: calc(50% - 25px);
    }

    .alerta {
        width: 100%;
        border-radius: 0 4px 4px 0;
    }

    .carousel-fix {
        max-width: 72vw;
    }

    .alerta-horizontal {
        width: 100%;
        border-radius: 4px;
    }

    .dados-monitoramento {
        background-color: var(--white);
        width: 100%;
        height: 500px;
        border-radius: 4px;
        overflow: hidden;
        border: solid 1px var(--default-border-color);
        .tab-icon {
            margin-right: 5px;
        }
    }

    .card {
        background-color: var(--white);
    }

    header {
        margin-bottom: 20px;

        .voltar:hover {
            cursor: pointer;
        }
    }
}
</style>

<style lang="scss">
.el-tabs--border-card {
    background: var(--white);
    border: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    border-radius: 4px !important;
}
</style>
